module.exports = __webpack_public_path__ + "static/img-milestone-c-5c3d3bb4d1a5166a6e8bf31701a392e3.png";